import { Component, effect, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuService } from '../../service/menu.service';
import { CommonModule } from '@angular/common';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { MenuItem } from '../../models/menu-item.model';
import { RequestStore } from 'src/app/features/common-data/stores/request.store';
import { UserRole } from 'src/app/core/auth/user/enum/user-role.enum';
import { UserStore } from 'src/app/core/auth/user/store/user.store';

@Component({
  selector: '[app-menu]',
  imports: [CommonModule, RouterModule, MenuItemComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})
export class MenuComponent {
  readonly menuItems = signal<MenuItem[]>([]);
  readonly userMenuItems = signal<MenuItem[]>([]);

  collapsed = false;

  private menuService = inject(MenuService);
  private requestStore = inject(RequestStore);
  private userStore = inject(UserStore);

  constructor() {
    effect((onCleanup) => {
      const user = this.userStore.user();
      const roleId = user?.roleId;
      const activeTenantId = this.userStore.activeTenant()?.id;
      const vendorId = user?.vendorIds?.[0];

      this.requestStore.stopOpenRequestsPolling();

      if (roleId === UserRole.Vendor && vendorId) {
        this.requestStore.startOpenRequestsPolling({ vendorId });
        this.requestStore.startUnreadRequestMessagesPolling({ vendorId });
      } else if (roleId === UserRole.Admin) {
        this.requestStore.startOpenRequestsPolling({ onlyAdmin: true });
      } else if (roleId === UserRole.Customer && activeTenantId) {
        this.requestStore.startOpenRequestsPolling({ clientId: activeTenantId });
      }

      onCleanup(() => {
        this.requestStore.stopOpenRequestsPolling();
        this.requestStore.stopUnreadRequestMessagesPolling();
      });
    });

    effect(() => {
      this.menuService.setRole(
        this.userStore.roles().find(r => r.id === this.userStore.user()?.roleId) ?? null
      );

      const menuitems = this.menuService.menuItems();

      if (
        this.userStore.user()?.roleId === UserRole.Vendor ||
        this.userStore.user()?.roleId === UserRole.Admin ||
        this.userStore.user()?.roleId === UserRole.Customer ||
        this.userStore.user()?.roleId === UserRole.SystemOwner
      ) {
        const item = menuitems[0]?.items?.find(m => !!m.badge);
        if (item) {
          item.badge = this.requestStore.openRequestCount().toString();
        }
      }

      this.menuItems.set(menuitems);
      this.userMenuItems.set(this.menuService.userMenuItems());
    });
  }

  isActive(item: MenuItem): boolean {
    return document.location.pathname.startsWith(item.routerLink?.[0] ?? '');
  }

  toggleSidebar(): void {
    this.collapsed = !this.collapsed;
  }
}